import nodule31 from "./nodule3-1";
import nodule32 from "./nodule3-2";
import nodule33 from "./nodule3-3";
import nodule34 from "./nodule3-4";
import nodule35 from "./nodule3-5";
import nodule36 from "./nodule3-6";
import nodule37 from "./nodule3-7";
import nodule38 from "./nodule3-8";
import nodule39 from "./nodule3-9";
import nodule310 from "./nodule3-10";
import nodule311 from "./nodule3-11";
import nodule312 from "./nodule3-12";
import nodule313 from "./nodule3-13";
import nodule314 from "./nodule3-14";
import nodule315 from "./nodule3-15";
import nodule316 from "./nodule3-16";
import nodule317 from "./nodule3-17";
import nodule318 from "./nodule3-18";
import nodule319 from "./nodule3-19";
import nodule320 from "./nodule3-20";

export default [
  nodule31,
  nodule32,
  nodule33,
  nodule34,
  nodule35,
  nodule36,
  nodule37,
  nodule38,
  nodule39,
  nodule310,
  nodule311,
  nodule312,
  nodule313,
  nodule314,
  nodule315,
  nodule316,
  nodule317,
  nodule318,
  nodule319,
  nodule320,
];
